"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredChunkMetadataSchema = void 0;
const zod_1 = require("zod");
const presets_1 = require("./presets");
exports.RequiredChunkMetadataSchema = zod_1.z
    .object({
    fileId: zod_1.z.string(),
    ocrPresetName: presets_1.OcrPresetNameSchema,
    chunkingPresetName: presets_1.ChunkingPresetNameSchema,
    chunkIndex: zod_1.z.number().int().nonnegative(),
})
    .passthrough();
//# sourceMappingURL=required-chunk-metadata.js.map